// Functional module: all UI logic as named exports
import React from 'react';
import DatePicker from 'react-datepicker';
import constants from '../../constants';

const { dateFormate } = constants;

export function renderOtaList(otaList, filterEventHandler) {
  return Object.keys(otaList).map(otaId => (
    <li
      key={otaId}
      className="ovr border_t_1 border_color_1 cursor_p pad10 btn5"
      onClick={event => filterEventHandler(event, { identifier: 'otachange', otaId })}
    >
      {otaList[otaId]['company_name']}
    </li>
  ));
}

export function RateInventoryFilter({ otaList, filterEventHandler, filterData, others, dateChangeHandler }) {
  return (
    <div className="cover pad_top_bot10">
      <div className="row">
        <div className="col-xs-12 col-md-2">
          <div className="inventory_dropdown_wrap ovr marg_bottom5">
            <div className="inventory_dropdown_fill d-full-height justify-content-center pad_lft_rht5 bg2">
              <div className="table_col table_fixed">
                <div className="tabcel align_middle">
                  {filterData.userId === 0 ? (
                    <div className="text_end pad_right15 fnt13 tu color1">SYSTEM</div>
                  ) : (
                    <div className="text_end pad_right15 fnt13 tu color1">
                      {otaList[filterData.userId]['company_name']}
                    </div>
                  )}
                </div>
                <div className="tabcel align_middle wdhpx20 tc">
                  <i className="fa fa-caret-down color1"> </i>
                </div>
              </div>
            </div>
            <div className="inventory_dropdown_colum bg1 shwd1 border_all_1 border_color_1 hides">
              <div className="inventory_dropdown_scroll">
                <ul className="ovr">
                  <li
                    className="ovr border_t_1 border_color_1 cursor_p pad10 btn5"
                    onClick={event => filterEventHandler(event, { identifier: 'otachange', otaId: 0 })}
                  >
                    SYSTEM
                  </li>
                  {renderOtaList(otaList, filterEventHandler)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-auto" key="1">
          {others.isPreviousDayShow === 1 ? (
            <div
              className="d-full-height justify-content-center tc"
              key="10dayprev"
              onClick={event => filterEventHandler(event, { identifier: '10dayprev', otaId: filterData.userId })}
            >
              <a className="ovr bld txt_btn2 cursor_p">
                <i className="fa fa-chevron-left align_middle marg_right3"></i>
                <span className="inline align_middle"> Previous 10 days</span>
              </a>
            </div>
          ) : null}
        </div>
        <div className="col-xs-12 col-md tc">
          <div className="inline wdhpx200 border_all_1 border_color_1">
            <div className="frm">
              <span className="fa_icon pad_lft_rht10">
                <i className="fa fa-calendar color2_5"> </i>
              </span>
              <DatePicker
                placeholderText="Select Date"
                title="Select Date"
                dateFormat={dateFormate}
                className="input pad_lft_rht10"
                name="date_from"
                minDate={new Date()}
                maxDate={others.endDate}
                selected={new Date(filterData.date_from)}
                onChange={event => dateChangeHandler(event, { key: 'date_from' })}
              />
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-md-auto" key="2">
          <div
            className="d-full-height justify-content-center tc"
            key="10daynext"
            onClick={event => filterEventHandler(event, { identifier: '10daynext', otaId: filterData.userId })}
          >
            <a className="ovr bld txt_btn2">
              <span className="inline align_middle marg_right3 cursor_p"> Next 10 days</span>
              <i className="fa fa-chevron-right align_middle"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
